import { c as _c } from "react/compiler-runtime";
import { useToggle } from '@onefootprint/hooks';
import { Button, Divider } from '@onefootprint/ui';
import Head from 'next/head';
import { useTranslation } from 'react-i18next';
import PermissionGate from '@/components/permission-gate';
import SectionHeader from '@/components/section-header';
import CreateDialog from './components/create-dialog';
import Roles from './components/roles';
import Table from './components/table';
const ApiKeys = () => {
  const $ = _c(40);
  const {
    t
  } = useTranslation("api-keys");
  const [isCreateDialogOpen, openCreateDialog, closeCreateDialog] = useToggle(false);
  let t0;
  if ($[0] !== t) {
    t0 = t(_temp);
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <Head><title>{t0}</title></Head>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t) {
    t2 = t(_temp2);
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <header className="hidden md:flex items-center justify-between mb-6"><h2 className="text-heading-2">{t2}</h2></header>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t) {
    t4 = t(_temp3);
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t) {
    t5 = t(_temp4);
    $[10] = t;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t) {
    t6 = t(_temp5);
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t) {
    t7 = t(_temp6);
    $[14] = t;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== openCreateDialog || $[17] !== t7) {
    t8 = <Button onClick={openCreateDialog} variant="primary">{t7}</Button>;
    $[16] = openCreateDialog;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t6 || $[20] !== t8) {
    t9 = <PermissionGate fallbackText={t6} scopeKind="api_keys">{t8}</PermissionGate>;
    $[19] = t6;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t4 || $[23] !== t5 || $[24] !== t9) {
    t10 = <SectionHeader title={t4} subtitle={t5}>{t9}</SectionHeader>;
    $[22] = t4;
    $[23] = t5;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  let t12;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Divider className="mb-4" />;
    t12 = <Table />;
    $[26] = t11;
    $[27] = t12;
  } else {
    t11 = $[26];
    t12 = $[27];
  }
  let t13;
  if ($[28] !== closeCreateDialog || $[29] !== isCreateDialogOpen) {
    t13 = <CreateDialog open={isCreateDialogOpen} onClose={closeCreateDialog} />;
    $[28] = closeCreateDialog;
    $[29] = isCreateDialogOpen;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  let t15;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div className="mt-5 md:mt-9" />;
    t15 = <Roles />;
    $[31] = t14;
    $[32] = t15;
  } else {
    t14 = $[31];
    t15 = $[32];
  }
  let t16;
  if ($[33] !== t13) {
    t16 = <div>{t12}{t13}{t14}{t15}</div>;
    $[33] = t13;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== t1 || $[36] !== t10 || $[37] !== t16 || $[38] !== t3) {
    t17 = <>{t1}{t3}{t10}{t11}{t16}</>;
    $[35] = t1;
    $[36] = t10;
    $[37] = t16;
    $[38] = t3;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  return t17;
};
export default ApiKeys;
function _temp($) {
  return $.pageTitle;
}
function _temp2($_0) {
  return $_0.metaTitle;
}
function _temp3($_1) {
  return $_1.header.title;
}
function _temp4($_2) {
  return $_2.header.subtitle;
}
function _temp5($_3) {
  return $_3.header.ctaNotAllowed;
}
function _temp6($_4) {
  return $_4.header.cta;
}